var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixisLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7,49c-14.9,0-28.1-7.5-36-19l-14.4,10.8c11.1,15.8,29.5,26.2,50.4,26.2s39.2-10.4,50.4-26.2l-14.4-10.8c-7.8,11.5-21,19-36,19Z",
    fill: "#1d1d1b",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7,91.2c14.9,0,28.1,7.5,36,19l14.4-10.8c-11.1-15.8-29.5-26.2-50.4-26.2s-39.2,10.4-50.4,26.2l14.4,10.8c7.8-11.5,21-19,36-19Z",
    fill: "#1d1d1b",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixisLogo);
export default __webpack_public_path__ + "static/media/PixisLogo.4e7a2a75449bc1c404caef0770858f66.svg";
export { ForwardRef as ReactComponent };